import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import Swal from 'sweetalert2';
import { Candidates } from '../../models/candidates.model';
import { UsersService } from '../../services/users.service';
import { FunctionsService } from '../../services/functions.service';
import { HttpService } from '../../services/http.service';
import { Trainings } from '../../models/trainings.model';
import { Professions } from 'src/app/models/professions.model';
import { CandidatesProfiles } from '../../models/candidatesProfiles.model';
import { CandidatesExperiences } from 'src/app/models/candidatesExperiences.model';
import { AreaActivities } from '../../models/areaActivities.model';
import { CandidatesTrainings } from '../../models/candidatesTrainings.model';
import { CandidatesLanguages } from '../../models/candidatesLanguages.model';
import { Languages } from 'src/app/models/languages.model';
import { CandidatesSkills } from '../../models/candidatesSkills.model';
import { Skills } from '../../models/skills.model';
import { CandidatesCertificates } from 'src/app/models/candidatesCertificates.model';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-candidat-infos',
  templateUrl: './candidat-infos.component.html',
  styleUrls: ['./candidat-infos.component.scss']
})
export class CandidatInfosComponent implements OnInit {
  candidates: Candidates = new Candidates([]);
  profileIsLoading: boolean = false;
  personalInfoIsLoading: boolean = false;
  profilesForm: FormGroup = new FormGroup({});
  candidatesProfiles: CandidatesProfiles = new CandidatesProfiles({});
  candidateProfileList: CandidatesProfiles[] = [];
  tempWorkerValue: any;
  driverLicenceValue: any;
  passportValue: any;
  experienceProValue: any
  cvValue: any;
  cvFile: any;
  cvPath: any;
  idcardValue: any;
  idcardFile: any;
  idCard: any;
  jobIDToApply: any;
  showBtnToGoApplyJob = false;
  trainingList: Trainings[] = [];
  professionList: Professions[] = [];
  personalInfoForm: FormGroup = new FormGroup({});
  totalFillingRate = 0;
  personalInfoRate = 0;
  profileRate = 0;
  experienceRate = 0;
  trainingRate = 0;
  languageRate = 0;
  skillRate = 0;
  countryData: any;
  countryList: any[] = [];
  cityList: any[] = [];
  areaActivityList: AreaActivities[] = [];
  dateObj = new Date();
  currentMonth = (this.dateObj.getUTCMonth() + 1 < 10) ? '0' + (this.dateObj.getUTCMonth() + 1) : this.dateObj.getUTCMonth() + 1;
  currentYear = this.dateObj.getUTCFullYear();
  attestationFile: any = null;

  constructor(private router: Router, private formBuilder: FormBuilder, private usersService: UsersService, public functionsService: FunctionsService, private httpService: HttpService) {

    this.candidates = this.usersService.getCurrentUser();
    if (usersService.getUserType() != 'candidat') {
      this.router.navigate(['/not-found']);
    }

    this.candidates = this.usersService.getCurrentUser();
    this.trainingList = this.functionsService.getTrainingsList();
    this.professionList = this.functionsService.getProfessionsList();

    if (localStorage.getItem('jobIDToApply') && localStorage.getItem('jobIDToApply') != undefined) {
      this.jobIDToApply = localStorage.getItem("jobIDToApply");

      this.showBtnToGoApplyJob = true;
    }
  }

  ngOnInit(): void {

    this.initPersonalInfoForm();
    this.calculateTotalFillingRate();
    this.initProfileForm();
    this.getCandidateProfiles();
    this.profilesForm;
  }
  calculateTotalFillingRate() {

    if (this.candidates.getGender() !== null && this.candidates.getGender() !== '') {
      this.personalInfoRate = 20;
    } else {
      this.personalInfoRate = 0;
    }

    if (this.candidatesProfiles.getProfessions() && this.candidatesProfiles.getProfessions().getLibelle() != undefined) {
      this.profileRate = 20;
    } else {
      this.profileRate = 0;
    }

    if (this.candidates.getCandidatesTrainings().length > 0) {
      this.trainingRate = 15;
    } else {
      this.trainingRate = 0;
    }

    if (this.candidates.getCandidatesLanguages().length > 0) {
      this.languageRate = 15;
    } else {
      this.languageRate = 0;
    }

    if (this.candidates.getCandidatesSkills().length > 0) {
      this.skillRate = 15;
    } else {
      this.skillRate = 0;
    }

    if (this.candidates.getCandidatesExperiences().length > 0) {
      this.experienceRate = 15;
    } else {
      this.experienceRate = 0;
    }

    this.totalFillingRate = this.personalInfoRate + this.profileRate + this.experienceRate + this.trainingRate + this.languageRate + this.skillRate;

    localStorage.setItem('totalFillingRate', JSON.stringify(this.totalFillingRate));
  }

  initPersonalInfoForm() {
    this.calculateTotalFillingRate();
    this.loadCountries();

    this.tempWorkerValue = this.candidates.getTempWorker();
    this.driverLicenceValue = this.candidates.getDriverLicence();
    this.passportValue = this.candidates.getPassport();
    this.cvValue = this.candidates.getCvPath();
    this.cvPath = (this.candidates.getCvPath() != null) ? this.candidates.getCvPath() : '';
    this.idcardValue = this.candidates.getIdCard();
    this.idCard = (this.candidates.getIdCard() != null) ? this.candidates.getIdCard() : '';
    this.personalInfoForm = this.formBuilder.group({
      profil: this.formBuilder.array([], [Validators.required]),
      gender: [this.candidates.getGender(), Validators.required],
      // profil: [this.candidates.getProfil(), Validators.required],
      firstName: [this.candidates.getFirstName(), Validators.required],
      lastName: [this.candidates.getLastName(), Validators.required],
      email: [this.candidates.getEmail(), [Validators.required, Validators.email]],
      dateBirth: [this.candidates.getDateBirth(), Validators.required],
      phone1: [this.candidates.getPhone1(), Validators.required],
      phone2: [(this.candidates.getPhone2() == null || this.candidates.getPhone2() == 'null') ? '' : this.candidates.getPhone2()],
      maritalStatus: [(this.candidates.getMaritalStatus() == null || this.candidates.getMaritalStatus() == 'null') ? '' : this.candidates.getMaritalStatus()],
      country: [(this.candidates.getCountry() == null || this.candidates.getCountry() == 'null') ? '' : this.candidates.getCountry()],
      city: [(this.candidates.getCity() == null || this.candidates.getCity() == 'null') ? '' : this.candidates.getCity()],
    });
  }
  onSubmitPersonalInfoForm(): any {

    if (this.cvValue == null && this.cvFile == null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Veuillez joindre votre CV.',
      })
      return false;
    }

    if (this.idcardValue == null && this.idcardFile == null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Veuillez joindre votre pièce d\'identité (CNI/Passport)',
      })

      return false;
    }

    let formValue: any = this.personalInfoForm.value;
    // formValue['tempWorker'] = this.getRadioChoice('tempWorkerYes', 'tempWorkerNo');
    // formValue['driverLicence'] = this.getRadioChoice('driveLicenceYes', 'driveLicenceNo');
    // formValue['passport'] = this.getRadioChoice('passportYes', 'passportNo');
    formValue['cvFile'] = this.cvFile;
    formValue['idcard'] = this.idcardFile;

    console.log(formValue);
    this.personalInfoIsLoading = true;
    this.httpService.editCandidateData(formValue).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentCandidate', JSON.stringify(data));
          this.personalInfoIsLoading = false;
          this.candidates = this.usersService.getCurrentUser();
          this.initPersonalInfoForm();
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Vos informations personnelles ont été mises à jour.',
          })
        }
      },
      (error) => {
        console.log(error);
        this.personalInfoIsLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        })
      }
    );
  }

  initProfileForm() {
    this.calculateTotalFillingRate();
    this.profilesForm = this.formBuilder.group({
      profession_id: ['', Validators.required],
    });
    // this.getCandidateProfiles();
    this.professionList = this.functionsService.getProfessionsList();

    let professions = (this.candidatesProfiles.getProfessions() != undefined) ? new Professions(this.candidatesProfiles.getProfessions()) : new Professions({});
    // if (professions.getId() != undefined && professions.getId() != null) {
    //   this.profileRate = 20;
    // }
  }

  onSubmitProfileForm(): any {
    let formValue: any = this.profilesForm.value;
    this.profileIsLoading = true;
    console.log(formValue);

    this.httpService.createProfile(formValue, this.candidates.getToken()).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          localStorage.setItem('currentCandidate', JSON.stringify(data));
          this.profileIsLoading = false;
          this.initProfileForm();
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Votre profile a été mise à jour.',
          })
          this.candidates = this.usersService.getCurrentUser();
          this.initProfileForm();
          this.getCandidateProfiles();
        }
      },
      (error) => {
        console.log(error);
        this.profileIsLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        })
      }
    );
  }

  getCandidateProfiles() {
    console.log(this.candidates);
    const candidateProfile: any = this.candidates.getCandidatesProfiles();
    console.log(candidateProfile);

    this.candidateProfileList = [];
    candidateProfile.forEach((element: any) => {
      let candidatesProfiles = new CandidatesProfiles(element);
      this.candidateProfileList.push(candidatesProfiles);
    });
    return this.candidateProfileList;
  }



  async onCheckboxProfilChange(e: any) {
    const profil: FormArray = this.personalInfoForm.get('profil') as FormArray;

    if (e.target.checked) {

      profil.push(new FormControl(e.target.value));

    } else {

      const index = profil.controls.findIndex(x => x.value === e.target.value);

      profil.removeAt(index);
    }
  }

  getRadioChoice(idRadioYes: string, idRadioNo: string): any {
    const radioYesElement: any = document.getElementById(idRadioYes);
    const radioNoElement: any = document.getElementById(idRadioNo);

    if (radioYesElement.checked) {

      return true;
    }
    if (radioNoElement.checked)
      return false;

    if (radioYesElement.checked == false && radioNoElement.checked == false)
      return false;
  }
  loadCountries() {
    this.httpService.getCountries().subscribe(data => {
      this.countryData = data;
      const countries: any = data;
      let countryList: any[] = [];
      countries.find((item: { country: any; }) => {
        const country = item.country
        if (!countryList.includes(country)) {
          countryList.push(country)
        }
      });

      this.countryList = countryList.sort();

      this.cityList = this.functionsService.findCitiesOfCountry(this.candidates.getCountry(), this.countryData);
    })
  }

  async chooseNewIdcard() {
    const { value: file } = await Swal.fire({
      title: 'Selectionner votre carte d\'identité ou passport',
      input: 'file',
      inputAttributes: {
        'accept': 'application/pdf',
        'aria-label': 'CNI/passport selectionné'
      }
    });

    if (file) {
      if (file.type != 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Le fichier doit être de type pdf'
        });
      } else if (file.size > '1100000') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'La taille du fichier ne peut excéder 1Mo'
        });
      } else {
        this.idcardFile = file;
        Swal.fire({
          icon: 'success',
          title: 'Fichier chargé',
          text: 'Chargement du fichier terminé.'
        });
      }
    }
  }
  async chooseNewCV() {
    const { value: file } = await Swal.fire({
      title: 'Selectionner votre CV',
      input: 'file',
      inputAttributes: {
        'accept': 'application/pdf',
        'aria-label': 'Cv selectionné'
      }
    });

    if (file) {
      if (file.type != 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Le fichier doit être de type pdf'
        });
      } else if (file.size > '1100000') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'La taille du fichier ne peut excéder 1Mo'
        });
      } else {
        this.cvFile = file;
        Swal.fire({
          icon: 'success',
          title: 'Fichier chargé',
          text: 'Chargement du fichier terminé.'
        });
      }
    }
  }
  onChangeCountry(country: string) {
    this.cityList = this.functionsService.findCitiesOfCountry(country, this.countryData);
  }

}
